import { TulipAssetConstant } from "../TulipAssetConstants";
import { EntityController } from "./EntityController";
import { COCOS_PLAN_MODULE_PATH } from "../../constants";
import { PlanManager } from "../../cocosPlan";
import { Commands, ComponentConstants, CorniceType, Room, SceneConstants } from "@rhinov/savane-js";
import { ARRMGR_CLOUDINARY_ALLOWED, ARRMGR_CLOUDINARY_URL, getFrontUrl, getMediaUrl } from "@rhinov/asset-manager-service";



export class RoomEntityController extends EntityController {

    declare entity: Room;
    modelList: any;

    constructor(entity: Room, panel: any, deliverable: any, openAssetDetailCallback: CallableFunction) {
        super(entity, panel, deliverable, openAssetDetailCallback);
        this.modelList = TulipAssetConstant.getinstance().getModelList(this.entity);
        this.updatepreviewCornice();
    }

    getMinRoomHeight(): number {
        let minimal = 0;
        for (let i = 0; i < this.entity.walls.length; ++i) {
            for (let j = 0; j < this.entity.walls[i].joineries.length; ++j) {
                if (this.entity.walls[i].joineries[j].joineryType !== SceneConstants.JoineryType.velux) {
                    if (this.entity.walls[i].joineries[j].height + this.entity.walls[i].joineries[j].floorHeight >= minimal) {
                        minimal = this.entity.walls[i].joineries[j].height + this.entity.walls[i].joineries[j].floorHeight;
                    }
                }
            }
        }
        return minimal;
    }

    openAssetDetail(res: any) {
        var path = "decorated-walls/";
        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(getFrontUrl() + path + res._id);
            return;
        }
        window.open(getFrontUrl() + path + res._id);
    };

    isCorniceModelSelected(modele: any): boolean {
        var obj = this.entity;
        var component = obj.getComponent(ComponentConstants.ComponentType.CorniceType) as CorniceType;

        if (component !== null) {
            if (component.corniceTypeId === modele._id) {
                return (true);
            }
        }

        return (false);
    };

    updateCorniceModeleType(modele: any) {
        var obj = this.entity;
        var component = obj.getComponent(ComponentConstants.ComponentType.CorniceType) as CorniceType;

        if (component !== null) {
            PlanManager.getInstance().executeCommand(new Commands.EditComponentCommand(component, modele._id));
        }
        else {
            PlanManager.getInstance().executeCommand(new Commands.AddComponentCommand(new CorniceType(modele._id), obj, true, false));
        }
        this.itemPreview = this.getCornicePreviewUrl(modele);
    };

    openEntityDetail(){
        var path = "decorated-walls/";
        var comp = this.entity.getComponent(ComponentConstants.ComponentType.CorniceType) as CorniceType;
        var id = comp.corniceTypeId;
        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(getFrontUrl() + path + id);
            return;
        }
        window.open(getFrontUrl() + path + id);
    };

    getCornicePreviewUrl(modele: any): string {
        if (modele !== null) {
            var url = getMediaUrl() +
                'decoratedWalls/' +
                modele._id +
                '/medias/previews/preview1-sm.webp';
            if (ARRMGR_CLOUDINARY_ALLOWED) {
                url = ARRMGR_CLOUDINARY_URL + modele._id + '/medias/previews/preview1-sm.webp';
            }
            return (url);
        }
        else {
            return (COCOS_PLAN_MODULE_PATH + "cocos/resources/loading.gif");
        }
    }

    updateselectCorniceModel() {
        var cornice = document.getElementById('cornicesContainer');
        if (!cornice) return;
        if (!this.entity.cornices) {
            cornice.classList.add('hide');
        }
        else {
            cornice.classList.remove('hide');
            let listcornice = document.getElementById('cornicesList');
            let list = document.getElementById('propertiesList');
            if (list && listcornice) {
                listcornice.style.maxHeight = list.getBoundingClientRect().height * 0.9 + 'px'; 
            }
        }
    }

    updatepreviewCornice() {
        let image = document.getElementById('previewCurrentCornice');
        if (!image) return;
        if (!this.entity.cornices) {
            image.classList.add('hide');
        }
        else {
            image.classList.remove('hide'); 

            var component = this.entity.getComponent(ComponentConstants.ComponentType.CorniceType) as CorniceType;
            if (component !== null) {
                this.itemPreview = getMediaUrl() + 'decoratedWalls/' + component.corniceTypeId + '/medias/previews/preview1-sm.webp';
                if (ARRMGR_CLOUDINARY_ALLOWED) {
                    this.itemPreview = ARRMGR_CLOUDINARY_URL + component.corniceTypeId + '/medias/previews/preview1-sm.webp';
                }
            }
            
            if (image.getElementsByTagName("img")[0]) {
                image.getElementsByTagName("img")[0].src = this.itemPreview ?? '';
            }
        }
    }
}